$(document).ready(function() {


    $('a.callback').prop('disabled', false);

    $('body').on('click', '.js-callback:not(form)', function (e) {
        e.preventDefault();
        var instance = $(this);

        if (instance.prop('disabled'))
            return false;

        instance.prop('disabled', true);
        instance.addClass('idle');
        var urlCallback = !!instance.data('url') ? instance.data('url') : '/ajax-callback';

        $.ajax({
            url: urlCallback,
            type: 'POST',
            data: instance.data(),
            success: function (json) {
                instance.prop('disabled', false);

                instance.removeClass('idle');

                if (json.result != 'ok') {
                    if (json.message)
                        show_error(json.message);

                    return;
                }

                if (json.action)
                    eval(json.action);

                if (json.message)
                    show_ok(json.title, json.message, json.redirect);
                else if (json.redirect)
                    location.href = json.redirect;
                else if (json.redirect == "")
                    location.reload();
            }
        });

        return false;
    });

    $('body').on('click', 'a.js-callback-yes-no', function (e) {
        e.preventDefault();
        var instance = $(this);
        var message = !!instance.data('message') ? instance.data('message') : 'Вы действительно хотите удалить?';
        var title = !!instance.data('title') ? instance.data('title') : 'Вы уверены?';
        var okButton = !!instance.data('okbutton') ? instance.data('okbutton') : 'Да';
        var cancelButton = !!instance.data('cancel') ? instance.data('cancel') : 'Отмена';

        var urlCallback = !!instance.closest('form').data('url') ? instance.closest('form').data('url') : '/ajax-callback';

        swal({
            title: title,
            text: message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: cancelButton,
            confirmButtonText: okButton
        }).then(function () {

            if (instance.prop('disabled'))
                return false;

            instance.prop('disabled', true);
            instance.addClass('idle');

            $.ajax({
                url: urlCallback,
                type: 'POST',
                data: instance.data(),
                success: function (json) {
                    instance.prop('disabled', false);
                    instance.removeClass('idle');

                    if (json.result != 'ok') {
                        if (json.message)
                            show_error(json.message);

                        return;
                    }

                    if (json.action)
                        eval(json.action);

                    if (json.message)
                        show_ok(json.title, json.message, json.redirect);
                    else if (json.redirect)
                        location.href = json.redirect;
                    else if (json.redirect == "")
                        location.reload();
                }
            });
        });

        return false;
    });

    $('form.js-callback [type=submit]').prop('disabled', false);

    $('body').on('submit', 'form.js-callback', function (e) {
    /*$('form.js-callback').submit(function (e) {*/
        e.preventDefault();

        var instance = $(this);

        try {
            if (typeof(tinyMCE) != 'undefined')
                tinyMCE.triggerSave();

        } catch (e) {
            console.log(e);
        }


        if (instance.find("button[type=submit]:focus").hasClass('js-submit-back'))
            instance.find('input[name=js_back]').val('1');
        else
            instance.find('input[name=js_back]').val('0');


        instance.find('.error').removeClass('error');
        var button_title = instance.find('button[type=submit]').text();

        instance.find('button[type=submit]').prop('disabled', true);
        instance.find('button[type=submit]').addClass('idle');

        var urlCallback = !!instance.closest('form').data('url') ? instance.closest('form').data('url') : '/ajax-callback';
        var options = {
            type: 'POST',
            url: urlCallback,
            success: function (json) {

                instance.find('button[type=submit]').prop('disabled', false);
                instance.find('button[type=submit]').removeClass('idle');

                if (json.result != 'ok') {
                    if (json.message)
                        show_error(json.message);

                    if (typeof(json.fields) != 'undefined') {
                        json.fields.every(function (el, i) {
                            instance.find('[name=' + el + ']').addClass('error');
                            instance.find('.wrap-error-' + el).addClass('error');
                            return true;
                        });
                    }

                    return;
                }


                if (json.action)
                    eval(json.action);

                if (json.message) {
                    show_ok(json.title, json.message, json.redirect, json.button)
                }
                else if (json.redirect)
                    location.href = json.redirect;
                else if (json.redirect == "")
                    location.reload();

            },

            error: function () {
                instance.find('button[type=submit]').prop('disabled', false);
                instance.find('button[type=submit]').text(button_title);
                instance.find('button[type=submit]').removeClass('idle');
                show_error('Error');
            }
        };

        $(this).ajaxSubmit(options);
    });

    if ($('#map').length > 0) {
        ymaps.ready(init);
        function init() {
            var strCenter = $('#map').data('center').split(',');
            var centerLon = parseFloat(strCenter[0]);
            var centerLat = parseFloat(strCenter[1]);

            if ($('#map').length) {
                map = new ymaps.Map("map", {
                    center: [centerLon, centerLat],
                    zoom: 15
                });

                for (var i = 0; i < mapCoords.length; i++) {
                    var myPlacemark = new ymaps.Placemark([mapCoords[i].lat, mapCoords[i].lon], {
                        balloonContent: mapCoords[i].title
                    }, {

                        iconImageHref:'/images/pin.png',
                        iconImageSize:[36,58],
                        iconImageOffset:[-18,-58]

                    });
                    map.geoObjects.add(myPlacemark);
                }
                /* var myPlacemark = new ymaps.Placemark([lon, lat], {
                 balloonContentHeader: "Апельсин"
                 }, {
                 iconImageSize: [30, 40],
                 iconImageOffset: [-15, -50],

                 });
                 map.geoObjects.add(myPlacemark);*/
            }
        };
    }

    $("input.amount-products").bind('change', function () {

        var amount = $(this).val();
        var instance = $(this);
        instance.data('amount', amount);

        if (instance.prop('disabled'))
            return false;

        instance.prop('disabled', true);
        instance.addClass('idle');
        var urlCallback = !!instance.data('url') ? instance.data('url') : '/ajax-callback';

        $.ajax({
            url: urlCallback,
            type: 'POST',
            data: instance.data(),
            success: function (json) {
                instance.prop('disabled', false);

                instance.removeClass('idle');

                if (json.result != 'ok') {
                    if (json.message)
                        show_error(json.message);

                    return;
                }

                if (json.action)
                    eval(json.action);

                if (json.message)
                    show_ok(json.title, json.message, json.redirect);
                else if (json.redirect)
                    location.href = json.redirect;
                else if (json.redirect == "")
                    location.reload();
            }
        });

    });

    if($('#checkout-form select[name=country_id]').length > 0)
    {
        updateDeliveryInfo(
            $('#checkout-form select[name=country_id]').val(),
            'SimplePost',
            $('#checkout-form select[name=country_id]').data('handler'),
            $('#checkout-form select[name=country_id]').data('_token'));
    }


    $('#checkout-form select[name=country_id]').change(function(e) {
        updateDeliveryInfo(
            $(this).val(),
            'SimplePost',
            $(this).data('handler'),
            $(this).data('_token'),
            $('input#co-state').val(),
            $('input#co_postcode').val());

        /*var countryWithCities = [13, 21, 88, 96, 173, 221];

        if (countryWithCities.indexOf(parseInt($(this).val())) != -1) {
            //change city
            $.ajax({
                url: '/ajax-callback',
                type: 'POST',
                data: {
                    country_id: $(this).val(),
                    handler: 'eyJpdiI6IjcySU9laG5DTlNzZWZBSHFWQlhrRmc9PSIsInZhbHVlIjoiXC92TWN0dVhLTUo2TjIwYVhESXVyR0MwMVBFbGNKRlJoME5RSDlLa0RpdTQ9IiwibWFjIjoiZGU4ZTJlNGMwMmM1NzY3MzZmODFkNzNlNDVkMTVlZGM4YjQzMWMxMmJhZTg0ZmI0YTE2NTkzODEwY2MxMTcxYSJ9',
                    _token: $(this).data('_token')
                },
                success: function (json) {
                    if (json.result != 'ok') {
                        if (json.message)
                            show_error(json.message);

                        return;
                    }

                    if (json.action)
                        eval(json.action);

                    if (json.message)
                        show_ok(json.title, json.message, json.redirect);
                    else if (json.redirect)
                        location.href = json.redirect;
                    else if (json.redirect == "")
                        location.reload();
                }
            });
        }*/
    });

    $('input#co-state, input#co_postcode').change(function () {      
        updateDeliveryInfo(
            $('#checkout-form select[name=country_id]').val(),
            'SimplePost',
            $('#checkout-form select[name=country_id]').data('handler'),
            $('#checkout-form select[name=country_id]').data('_token'),
            $('input#co-state').val(),
            $('input#co_postcode').val());
    });

    $('body').on('change', 'input[name=delivery][type=radio]', function () {
        updateTotalPriceWithDelivery();
    });
	
	
	$('#co-state').autocomplete({
		source: function( request, response ){
			// Fetch data
			var instance = $(this);
			var urlCallback = !!instance.closest('form').data('url') ? instance.closest('form').data('url') : '/autocomplete/fetchCities';
			$.ajax({
				url:urlCallback,
				type:"POST",
				dataType: "json",
				data:{
					country_id: $('select[name="country_id"]').val(), 
					query:request.term,
					_token: $('input[name="_token"]').val()
				},
				success:function(data){
					response( data );
				}
			});
		},
		minLength:3,
		select: function (event,ui){
			$('#co-state').val(ui.item.value);
			updateDeliveryInfo(
				$('select[name="country_id"]').val(),
				'SimplePost',
				$('select[name="country_id"]').data('handler'),
				$('select[name="country_id"]').data('_token'),
				$('#co-state').val(),
				$('#co_postcode').val());
			return true;	
		}
	});
	
	$('#co_postcode').autocomplete({
		source: function( request, response ){
			// Fetch data
			var instance = $(this);
			var urlCallback = !!instance.closest('form').data('url') ? instance.closest('form').data('url') : '/autocomplete/fetchPostcodes';
			$.ajax({
				url:urlCallback,
				type:"POST",
				dataType: "json",
				data:{
					country_id: $('select[name="country_id"]').val(), 					
					query:request.term,
					_token: $('input[name="_token"]').val()
				},
				success:function(data){
					response( data );
				}
			});
		},
		minLength:2,
		select: function (event,ui){
			$('#co_postcode').val(ui.item.value);
			updateDeliveryInfo(
				$('select[name="country_id"]').val(),
				'SimplePost',
				$('select[name="country_id"]').data('handler'),
				$('select[name="country_id"]').data('_token'),
				$('#co-state').val(),
				$('#co_postcode').val());
			return true;	
		}
	});
});

function updateTotalPriceWithDelivery() {
    var instanceSelectDelivery = $('input[name=delivery][type=radio]:checked');

    var price_delivery = parseFloat(instanceSelectDelivery.data('price'));
    var price_cart = parseFloat($('#total_price').data('price_cart'));
    var percent_pay = parseFloat($('#total_price').data('percent_pay'));

    var pricePayPal = (percent_pay/100) * (price_delivery + price_cart);

    var total_price = (price_delivery + price_cart) + pricePayPal;

    $('#percent_pay_pal').text(pricePayPal.toFixed(2))
    $('#total_price').text(total_price.toFixed(2));
}

function updateDeliveryInfo(countryId, deliveryType, handler, token, city, index) {
    city = (!!city) ? city : 0;
    index = (!!index) ? index : 0;
    $('#final_price').html('<img src="/img/loading.gif" alt="">');
    $.ajax({
        url: '/ajax-callback',
        type: 'POST',
        data: {
            country_id: countryId,
            delivery_type: deliveryType,
            city: city,
            handler: handler,
            index: index,
            _token: token
        },
        success: function (json) {
            if (json.result != 'ok') {
                if (json.message)
                    show_error(json.message);

                return;
            }

            if (json.action)
                eval(json.action);

            if (json.message)
                show_ok(json.title, json.message, json.redirect);
            else if (json.redirect)
                location.href = json.redirect;
            else if (json.redirect == "")
                location.reload();
        }
    });
}


function show_error(message) {
    if (!message)
        return;

    $.toast({
        text: message,
        heading: 'Ошибка',
        showHideTransition: 'fade',
        allowToastClose: true,
        hideAfter: 7000,
        stack: 5,
        position: 'bottom-right',

        bgColor: '#E31D24',
        textColor: '#ffffff',
        textAlign: 'left',
        beforeShow: function () {
        },
        afterShown: function () {
        },
        beforeHide: function () {
        },
        afterHidden: function () {
        }
    });
}


function show_ok(title, message, redirect, action) {

    var closeOnConfirm = (typeof(redirect) == 'undefined');
    title = (typeof(title) == 'undefined') ? '' : title;

    swal({
        title: title,
        text: message,
        type: "success",
        showCancelButton: false,
        confirmButtonText: "OK",
        allowOutsideClick: false,
        closeOnConfirm: closeOnConfirm }).then(function() {
        if (!redirect || redirect.length == 0)
            location.reload();
        else {
            if (redirect != 'noredirect')
                location.href = redirect;
        }
    });

}